/* eslint-disable no-nested-ternary */
import React from 'react';
import type {} from 'styled-components/cssprop';
import { CSSProp } from 'styled-components';
import PropTypes from 'prop-types';
import { uuid } from '@carvana/purchase-utils';
import CheckCircle from '../check-circle';
import {
  CheckboxContainer,
  CircleIcon,
  CircleIconWrapper,
  CheckboxLabel,
  checkboxSize,
  HiddenCheckbox,
  CheckboxText,
  Icon,
  StyledCheckbox
} from './checkbox-next.styles';

type OnChangeHandler = (
  e: React.ChangeEvent<HTMLInputElement>,
  validate: () => void
) => void;
const defaultOnChange: OnChangeHandler = () => {};

const defaultProps = {
  textStyles: [] as CSSProp,
  text: null as React.ReactNode | null,
  checkCircle: false,
  disabled: false,
  round: false,
  value: false,
  uuid: uuid(),
  validate: () => {},
  'data-cv-test': '',
  id: undefined as string | undefined,
  onChange: defaultOnChange,
  backgroundColor: '#fff',
  checkmarkColor: '#00aed9'
};

const getCheckboxUI = (props: typeof defaultProps) => {
  const {
    value,
    checkCircle,
    round,
    disabled,
    backgroundColor = defaultProps.backgroundColor,
    checkmarkColor = defaultProps.checkmarkColor
  } = props || {};

  return checkCircle && !!value ? (
    <CheckCircle $green $size={checkboxSize} />
  ) : (
    <StyledCheckbox
      checked={value}
      round={round || checkCircle}
      disabled={disabled}
      backgroundColor={backgroundColor}
    >
      {round ? (
        <CircleIconWrapper viewBox="-7 -7 24 24">
          <CircleIcon />
        </CircleIconWrapper>
      ) : (
        <Icon viewBox="0 0 24 24" checkmarkColor={checkmarkColor}>
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      )}
    </StyledCheckbox>
  );
};

const Checkbox = (props = defaultProps as Partial<typeof defaultProps>) => {
  const {
    text,
    validate,
    disabled,
    value,
    onChange,
    textStyles,
    ...rest
  } = props;
  const { id } = rest;

  return (
    <>
      <CheckboxLabel htmlFor={id} data-cv-test={`${rest['data-cv-test']}Label`}>
        <CheckboxContainer data-cv-test={`${rest['data-cv-test']}Container`}>
          <HiddenCheckbox
            checked={value}
            onChange={e => onChange(e, validate)}
          />
          {getCheckboxUI(props)}
        </CheckboxContainer>

        {text && (
          <CheckboxText css={textStyles} disabled={disabled}>
            {text}
          </CheckboxText>
        )}
      </CheckboxLabel>
    </>
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  textStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node]),
  checkCircle: PropTypes.bool,
  onTouched: PropTypes.func,
  disabled: PropTypes.bool,
  round: PropTypes.bool,
  uuid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validate: PropTypes.func
};

export default Checkbox;
